import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Produits from "./pages/Produits";
import BolsKraft from "./pages/BolsKraft";
import SaladiersCarres from "./pages/SaladiersCarres";
import GobeletKraft from "./pages/GobeletKraft";
import GobeletsSmoothie from "./pages/GobeletsSmoothie";
import PotsGlace from "./pages/PotsGlace";
import BarquettesBateau from "./pages/BarquettesBateau";
import Pailles from "./pages/Pailles";
import PotsSoupe from "./pages/PotsSoupe";
import SacsKraft from "./pages/SacsKraft";
import PastaBox from "./pages/PastaBox";
import PotSauce from "./pages/PotSauce";
import PotDessert from "./pages/PotDessert";
import BoiteAccompagnement from "./pages/BoiteAccompagnement";
import SacBretelle from "./pages/SacBretelle";
import Couverts from "./pages/Couverts";
import SacPoubelle from "./pages/SacPoubelle";
import BobineThermique from "./pages/BobineThermique";
import Serviettes from "./pages/Serviettes";
import BobineEssuieMains from "./pages/BobineEssuieMains";
import Gants from "./pages/Gants";
import FilmEtirable from "./pages/FilmEtirable";
import FilmAluminium from "./pages/FilmAluminium";
import PelleHotdog from "./pages/PelleHotdog";
import Personnalisation from "./pages/Personnalisation";
import Valeurs from "./pages/Valeurs";
import Certifications from "./pages/Certifications";
import Devis from "./pages/Devis";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminDevis from "./pages/admin/AdminDevis";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminProduits from "./pages/admin/AdminProduits";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/produits" element={<Produits />} />
          <Route path="/produits/bols-kraft" element={<BolsKraft />} />
          <Route path="/produits/saladiers-carres" element={<SaladiersCarres />} />
          <Route path="/produits/gobelets-kraft" element={<GobeletKraft />} />
          <Route path="/produits/pots-glace" element={<PotsGlace />} />
          <Route path="/produits/gobelets-smoothie" element={<GobeletsSmoothie />} />
          <Route path="/produits/barquettes-bateau" element={<BarquettesBateau />} />
          <Route path="/produits/pailles" element={<Pailles />} />
          <Route path="/produits/pots-soupe" element={<PotsSoupe />} />
          <Route path="/produits/sacs-kraft" element={<SacsKraft />} />
          <Route path="/produits/pasta-box" element={<PastaBox />} />
          <Route path="/produits/pot-sauce" element={<PotSauce />} />
          <Route path="/produits/pot-dessert" element={<PotDessert />} />
          <Route path="/produits/boite-accompagnement" element={<BoiteAccompagnement />} />
          <Route path="/produits/sac-bretelle" element={<SacBretelle />} />
          <Route path="/produits/couverts" element={<Couverts />} />
          <Route path="/produits/sac-poubelle" element={<SacPoubelle />} />
          <Route path="/produits/bobine-thermique" element={<BobineThermique />} />
          <Route path="/produits/serviettes" element={<Serviettes />} />
          <Route path="/produits/bobine-essuie-mains" element={<BobineEssuieMains />} />
          <Route path="/produits/gants" element={<Gants />} />
          <Route path="/produits/film-etirable" element={<FilmEtirable />} />
          <Route path="/produits/film-aluminium" element={<FilmAluminium />} />
          <Route path="/produits/pelle-hotdog" element={<PelleHotdog />} />
          <Route path="/produits/personnalisation" element={<Personnalisation />} />
          <Route path="/valeurs" element={<Valeurs />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/devis" element={<Devis />} />
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/devis" element={<AdminDevis />} />
          <Route path="/admin/produits" element={<AdminProduits />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
